module.exports = __webpack_public_path__ + "img/Parkandride-icon.47fa80ac.svg";